export default {
  // Settings
  "settings": "设置",
  "profile": "个人资料",
  "security": "安全",
  "theme": "主题",
  "feedback": "反馈",
  "data": "数据",
  "appearance_settings": "外观设置",
  "select_theme": "选择您喜欢的主题",
  "light": "浅色",
  "dark": "深色",
  "system": "系统",
  "language_changed": "语言已更改为",
  "failed_update_language": "更新语言失败",
  "profile_settings": "个人资料设置",
  "username_cannot_change": "您无法更改用户名，还需等待",
  "more_days": "天",
  "email_cannot_change": "电子邮件无法更改",
  "profile_links": "个人资料链接",
  "link_one": "链接 1",
  "link_two": "链接 2",
  "password_change": "更改密码",
  "current_password": "当前密码",
  "new_password": "新密码",
  "confirm_password": "确认密码",
  "update_password": "更新密码",
  "password_must_be": "密码必须在8到25个字符之间",
  "security_questions": "安全问题",
  "security_question": "安全问题",
  "update_security_questions": "更新安全问题",
  "setup_security_questions": "设置安全问题",
  "select_question": "选择问题",
  "your_answer": "您的回答",
  "enter_your_answer": "输入您的回答",
  "submit_feedback": "提交反馈",
  "feedback_type": "反馈类型",
  "general_feedback": "一般反馈",
  "bug_report": "错误报告",
  "feature_request": "功能请求",
  "airport_request": "请求新机场",
  "airport_iata": "机场IATA代码",
  "airport_name": "机场名称",
  "airport_location": "机场位置",
  "your_feedback": "您的反馈",
  "data_management": "数据管理",
  "delete_all_films": "删除所有胶片",
  "delete_films_warning": "这将永久删除您库存中的所有胶片。此操作无法撤消。",
  "delete_all_reviews": "删除所有评论",
  "delete_reviews_warning": "这将永久删除您的所有评论。此操作无法撤消。",
  "delete_account": "删除账户",
  "delete_account_warning": "警告：此操作无法撤消。这将永久删除您的账户并从我们的服务器中删除所有数据。",
  "account_deleted_success": "您的账户已成功删除",
  "account_deletion_failed": "删除账户失败",
  "reviews_deleted_success": "您的所有评论已成功删除",
  "reviews_deletion_failed": "删除评论失败",
  "films_deleted_success": "您的所有胶片已成功删除",
  "films_deletion_failed": "删除胶片失败",
  "confirm_delete_films": "您确定要删除所有胶片吗？此操作无法撤消。",
  "confirm_delete_reviews": "您确定要删除所有评论吗？此操作无法撤消。",
  "confirm_delete_account": "您确定要删除您的账户吗？此操作无法撤消。",
  "create_username": "创建用户名",
  "username_required_description": "请为您的账户创建一个用户名。用户名必须唯一且可以包含字母、数字和下划线。",
  "username": "用户名",
  "username_placeholder": "输入用户名",
  "username_requirements": "用户名必须为4到25个字符，并且只能包含字母、数字和下划线。",
  "save_username": "保存用户名",
  "username_taken": "此用户名已被使用",
  "username_set_success": "用户名设置成功",
  "username_set_error": "设置用户名失败"
};
